export const GroupType = Object.freeze({
	Group: 'group',
	Project: 'project',
	Scrum: 'scrum',
	Collab: 'collab',
});
